import request from '../../../axios';
import {IGetListSubBrandPayload, IGetListSubBrandResponse} from './types';

interface IProps {
  pageParam: number;
  payload: IGetListSubBrandPayload;
}

export const getListSubProducts = async ({pageParam, payload}: IProps) => {
  const {data}: {data: IGetListSubBrandResponse} = await request.get(
    `/api/v2/store/list-sub-brand/input-group/${payload.inputGroupCode}`,
    {
      params: {
        page: pageParam,
        ...(payload.search && {search: payload.search}),
      },
    },
  );
  return data;
};
